import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from 'redux/actions/sessionActions';
import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';
import { Translate } from 'react-redux-i18n';

const Password = (props) => {
  const [values, setValues] = useState({
    pwdnew: '',
    pwdold: '',
    confirm: '',
    id: props.user_id,
    isValid: false,
  });

  const handleChange = (event) => {
    const next = {
      ...values,
      [event.target.name]: event.target.value,
    };
    next.isValid =
      next.pwdold.length > 0 &&
      next.pwdnew.length > 0 &&
      next.confirm.length > 0;
    setValues(next);
  };

  const onSubmit = (event) => {
    event.preventDefault();
    if (values.pwdnew !== values.confirm) {
      alertify.error('Passwords new are not the same');
      return;
    }
    props.resetPassword(values, props.token);
    setValues({
      pwdnew: '',
      pwdold: '',
      confirm: '',
      id: props.user_id,
      isValid: false,
    });
  };

  return (
    <div className="account-panel">
      <h2 className="account-panel-title">
        <Translate value="password" />
      </h2>
      <p className="account-panel-subtitle">
        <Translate value="update_password" />
      </p>

      <form className="account-password-form" onSubmit={onSubmit}>
        <div className="account-field">
          <label htmlFor="pwd-old">
            <Translate value="password_current" />
          </label>
          <input
            id="pwd-old"
            name="pwdold"
            onChange={handleChange}
            type="password"
            value={values.pwdold}
            autoComplete="current-password"
          />
        </div>
        <div className="account-field">
          <label htmlFor="pwd-new">
            <Translate value="password_new" />
          </label>
          <input
            id="pwd-new"
            name="pwdnew"
            onChange={handleChange}
            type="password"
            value={values.pwdnew}
            autoComplete="new-password"
          />
        </div>
        <div className="account-field">
          <label htmlFor="pwd-confirm">
            <Translate value="password_confirm" />
          </label>
          <input
            id="pwd-confirm"
            name="confirm"
            onChange={handleChange}
            type="password"
            value={values.confirm}
            autoComplete="new-password"
          />
        </div>
        <div className="account-actions">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={!values.isValid}
          >
            <Translate value="save" />
          </button>
        </div>
      </form>
    </div>
  );
};

Password.propTypes = {
  className: PropTypes.string,
};

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.token,
    item: reducer.session.auth,
  };
}

const mapDispatchToProps = (dispatch) => ({
  resetPassword: (params, token) => dispatch(actions.resetItem({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Password);
